<template>
	<div>
		<NuxtLayout name="default">
			<NuxtPage />
		</NuxtLayout>
		<ClientOnly>
			<Transition>
				<aside v-show="gdpr === 'unknown' && showCookieBanner">
					<strong>Diese Webseite verwendet Cookies</strong>
					<p>
						Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste gesammelt haben. <NuxtLink to="/privacy/" aria-label="Erfahren Sie mehr über unsere Datenschutzrichtlinien">Mehr zum Datenschutz erfahren</NuxtLink>.
					</p>
					<div>
						<button type="button" class="blue" @click="accept" role="button">Akzeptieren</button>
						<button type="button" @click="decline" role="button">Ablehnen</button>
					</div>
				</aside>
			</Transition>
		</ClientOnly>
	</div>
</template>

<script setup lang="ts">
const route = useRoute()
useHead({
	link: [
		{
			rel: 'canonical',
			href: `https://mailuft.com${route.fullPath}`,
		},
	],
})

const nuxtApp = useNuxtApp()

useSeoMeta({
	ogSiteName: nuxtApp.$config.public.company.name,
	ogUrl: `https://mailuft.com${route.fullPath}`,
	ogImage: 'https://mailuft.com/og-logo.jpg',
	twitterImage: 'https://mailuft.com/og-logo.jpg',
	ogType: 'website',
	twitterCard: 'summary_large_image',
	twitterSite: '@mailuft_com',
	twitterCreator: '@mailuft_com',
})

const showCookieBanner = computed(() =>
{
	return !route.meta.hideCookieBanner
})


const gdpr = computed(() => nuxtApp.$gdprCookie?.value)

watch(gdpr, newVal =>
{
	if( newVal === 'accepted' )
	{
		nuxtApp.$initAnalytics()
	}
	else if( newVal === 'declined' )
	{
		nuxtApp.$cancelAnalytics()
	}
})

function accept()
{
	nuxtApp.$gdprCookie.value = 'accepted'
}

function decline()
{
	nuxtApp.$gdprCookie.value = 'declined'
}
</script>

<style lang="css" scoped>
aside
{
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;
	font-size: 1.2rem;
	padding: 2.5rem 4rem;
	box-sizing: border-box;
	color: rgb(var(--black));
	background: rgb(var(--white));
	z-index: 10000;
}

aside strong
{
	font-size: 1.1em;
}

aside p
{
	margin: 1.5rem 0;
}

aside div
{
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
}

aside button
{
	display: inline-block;
	background: #6c757d;
	box-sizing: border-box;
	border: none;
	padding: .75rem 1rem;
	border-radius: .35rem;
	letter-spacing: 2px;
	font-weight: 500;
	font-size: 1.2rem;
	text-transform: uppercase;
	outline: none;
	color: #fff;
	cursor: pointer;
}

aside button.blue
{
	background: rgb(var(--blue));
}

.v-enter-active,
.v-leave-active
{
	transition: opacity .2s ease, transform .3s ease;
}

.v-enter-from,
.v-leave-to
{
	opacity: 0;
	transform: translateY(50px);
}

@media screen and (max-width: 600px)
{
	aside
	{
		padding: 1.5rem 2rem;
	}
}
</style>